import React from "react";
import { CSSTransition } from 'react-transition-group';
import { FuelInvoicesTable } from "./FuelInvoicesTable";
import { FuelInvoiceFilterType, IFuelInvoice, IFuelInvoiceRequest, IFuelInvoiceSortFields } from "models/fuel-invoice";
import { IPageResponse, SortDirection } from "common/interfaces/IPageResponse";
import { FuelInvoicePaymentModal } from "components/Modals/FuelInvoicePaymentModal/FuelInvoicePaymentModal";
import { BankType, DocumentPayment, PaymentMethodType } from "models/payment";
import { CustomerPermission, useAuthContext } from "services/context/authentication.context";

interface FuelInvoicesProps {
  payableInvoices: IFuelInvoice[]
  filters: { [key in FuelInvoiceFilterType]?: any };
  isRequesting: boolean;
  invoices: IPageResponse<IFuelInvoice> | null;
  unpaidInvoices: IPageResponse<IFuelInvoice> | null;
  paymentModalVisible: boolean;
  paymentStatus: string | null;
  pageRequest: IFuelInvoiceRequest;
  toggleModal: (state: boolean) => void;
  onPageChange: (targetPage: number) => void;
  onSortChange: (sortedByField: IFuelInvoiceSortFields, sortDirection: SortDirection) => void;
  beginPayment: (paymentMethodType: PaymentMethodType, documentPayments: DocumentPayment[], bankType?: BankType) => void;
}

export function FuelInvoices({
  payableInvoices,
  isRequesting,
  invoices,
  paymentModalVisible,
  paymentStatus,
  toggleModal,
  onPageChange,
  onSortChange,
  beginPayment
}: FuelInvoicesProps){
  const { hasPermission } = useAuthContext();

  const hasFactoringInvoices = payableInvoices?.some(invoice => !!invoice.remoteFactoring);

  return (
    <>
    {
      <CSSTransition in={payableInvoices.length > 0} timeout={250} unmountOnExit classNames="alert">
            <div className="alert alert-notification">
                <div className="d-flex justify-content-between align-items-center">
                    <span>Sul on {payableInvoices.length} tasumata arve{payableInvoices.length > 1 && 't'}</span>
                    {
                      hasFactoringInvoices ? (
                        <div className="font-weight-bold">
                          Faktooringu arveid palume tasuda pangaülekandega.
                        </div>
                      ) : (
                        <>
                          {
                            hasPermission(CustomerPermission.WEB_ADMIN) ? (
                              <button 
                                className="btn btn-dark" 
                                onClick={() => toggleModal(true)}
                              >
                                Maksa arved
                              </button>
                            ) : null
                          }
                        </>
                      )
                    }
                </div>
            </div>
        </CSSTransition>
    }
    {
        <CSSTransition in={paymentStatus !== null} timeout={250} unmountOnExit classNames="alert">
            {paymentStatus === 'success'
            ? <div className="alert alert-success"><i className="alert-icon icon__check"></i>Makse õnnestus!</div>
            : <div className="alert alert-notification">Makse ebaõnnestus!</div>
            }
        </CSSTransition>

    }
    {invoices !== null ?
        <FuelInvoicesTable 
          invoices={invoices}
          onPageChange={onPageChange}
          onSortChange={onSortChange}
          beginPayment={beginPayment}
          isRequesting={isRequesting}
        /> :
        null
    }
    {
        invoices ?
            <FuelInvoicePaymentModal
                visible={paymentModalVisible}
                handleModalHide={() => toggleModal(false)}
                onSubmit={beginPayment}
                payableInvoices={payableInvoices}
                paymentStatus={paymentStatus}
            /> : null
    }
    <div id="payment-response-form-container" className="d-none"></div>
  </>
  )
}